import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Route, useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { colorBackgroundBody } from '@/utils/palette';
import Layout from '../Layout';
import { toast } from 'react-toastify';

function ProtectedRoute({ children, isAuthenticated, type, path, ...rest }) {
  const { isLoggedIn } = useSelector(state => state.user);
  const [accountType, setAccountType] = useState('');
  const user = JSON.parse(localStorage.getItem('user'));
  const history = useHistory();


  // If account type is undefined, render the protected route without any restrictions
  if (accountType === undefined) {
    return (
      <div>
        <Layout />
        <ContainerWrap>
          <Route
            {...rest}
            render={({ location }) => (
              children
            )}
          />
        </ContainerWrap>
      </div>
    );
  }

  const isTransferAccount = accountType === 'transfer';
  const isPurchaseAccount = accountType === 'purchase';
  const restrictedPaths = ['/otcmarketplacedetail', '/safebox', '/otcmarketplacelists', '/livechat', '/support', '/chat', '/new-safebox', '/safeboxes', '/marketplace', '/homeproducts', '/home', '/storedetail', '/getmyorders', '/getmyapproval', '/getmyorderasbuyer', '/customoffers'];
  const restrictedPathsPurchase = ['/livechat', '/support', '/safebox', '/chat', '/new-safebox', '/safeboxes', '/marketplace', '/homeproducts', '/home', '/storedetail', '/getmyorders', '/getmyapproval', '/getmyorderasbuyer', '/customoffers'];

  // If not logged in, redirect to login page
  if (!isLoggedIn) {
    return <Route {...rest} render={() => history.push('/sign-in')} />;
  }

  // If account type is transfer and accessing restricted paths, show toast error
  if (isTransferAccount && restrictedPaths.includes(path)) {
    history.push('/finance'); // Redirect back
    toast.error('You cannot access from sub account');
    return null; // Don't render anything
  }
  if (isPurchaseAccount && restrictedPathsPurchase.includes(path)) {
    history.push('/finance') // Redirect back
    toast.error('You cannot access from sub account');
    return null; // Don't render anything
  }

  // Render the protected route
  return (
    <div>
      <Layout />
      <ContainerWrap>
        <Route
          {...rest}
          render={({ location }) => (
            children
          )}
        />
      </ContainerWrap>
    </div>
  );
}

export default ProtectedRoute;

const ContainerWrap = styled.div`
  padding-top: 66px;
  min-height: 100vh;
  background: transparent;

  @media (max-width: 768px) {
    padding-top: 30px;
  }
`;